import $app from './../main';
import forEach from 'lodash/forEach'

/**
 * Create instant, which represent response object
 * @param {Object} [data] - custom data
 * @param {Object} [response] - axios response object
 * @param {String} [message] - custom message to display
 */
export class ResponseWrapper {
  constructor (response) {
    this.data = response.data.data;
    this.status = response.status;
    this.code = response.data.code;
  }
}

/**
 * Create instant, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
export class ErrorWrapper extends Error {
  constructor (error) {
    super();

    if (error.response && error.response.status && (error.response.status == 401)) {
      $app.$log.warn('401 error fired');
      return $app.$router.push({name:'login'});
    }

    this.code = error.response ? error.response.status : false;
    this.errors = error.response ? error.response.data.errors : false;
    this.message = error.response ? error.response.data.message : false;
    this.name = error.response ? error.response.data.errorName: false;
  }

  apply = () => {
    if (this.code === 422) {
      return this.validate();
    } else {
      return this.alert();
    }
  };

  validate = () => {
    let result = [];
    forEach(this.errors, (error) => result.push(error.message));
    return result;
  };

  alert = () => {
    $app.$vs.notify({
      color: "danger",
      title: this.name,
      text: this.message
    });

    return [];
  };
}
